import { gameState, config } from '@js/index';
import { enablePointerEvents, disablePointerEvents } from '@utils/pointer-events-control';

export default class EndScene extends Phaser.Scene {
  constructor() {
    super({
      key: "EndScene",
    });
  }

  preload() {}

  create() {
    enablePointerEvents();

    if (gameState.correct >= 6) {
      gameState.gameWin = true;
    } else {
      gameState.gameWin = false;
    }
    gameState.retry = true;
    this.kawase = this.plugins.get("rexkawaseblurpipelineplugin");
    this.kawase.add(gameState.cam, config);

    this.add.sprite(0, 0, "sbg").setOrigin(0).setTint(0x000).setAlpha(0.75);

    this.confettiaudio = this.sound.add("confettiaudio").setVolume(0.2);

    this.rewardReveal = this.sound.add("reward_reveal").setVolume(0.2);

    this.endanim = false;
    this.cameras.main.fadeIn(500, 255, 255, 255);

    this.anims.create({
      key: "showglitter",
      frames: this.anims.generateFrameNames("glitter", {
        start: 0,
        end: 32,
        zeroPad: 0,
        prefix: "glitterAnim",
        suffix: ".png",
      }),
      frameRate: 15,
      repeat: -1,
    });

    this.anims.create({
      key: "circleopen",
      frames: this.anims.generateFrameNames("baseCircle", {
        start: 0,
        end: 74,
        zeroPad: 0,
        prefix: "baseCircleAnim",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: "rewardopen",
      frames: this.anims.generateFrameNames("rewardLight", {
        start: 0,
        end: 155,
        zeroPad: 0,
        prefix: "rewardLightAnim",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: "circleglitterloop",
      frames: this.anims.generateFrameNames("baseCircle", {
        start: 74,
        end: 155,
        zeroPad: 0,
        prefix: "baseCircleAnim",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: -1,
    });

    //this.endOverlay = this.add.sprite(config.width / 2, config.height / 2, "endScreenOverlay");
    this.spotlight = this.add.sprite(config.width / 2, config.height / 2, "spotlight");
    this.anims.create({
      key: "spotlightOpen",
      frames: this.anims.generateFrameNames("spotlight", {
        start: 0,
        end: 188,
        zeroPad: 0,
        prefix: "spotlight0",
        suffix: ".png",
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.anims.create({
      key: "spotlightClose",
      frames: this.anims.generateFrameNames("spotlight", {
        start: 189,
        end: 214,
        zeroPad: 0,
        prefix: "spotlight0",
        suffix: ".png",
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.endConfetti = this.add.sprite(config.width / 2, config.height / 2, "endConfetti");
    this.anims.create({
      key: "endConfetti",
      frames: this.anims.generateFrameNames("endConfetti", {
        start: 0,
        end: 120,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 40,
      repeat: 0,
    });

    this.time.delayedCall(2000, () => {
      this.spotlight.play("spotlightOpen");
    });

    this.gameOver = this.add.sprite(config.width / 2, config.height / 2, "gameOver").setAlpha(0);
    this.tweens.add({
      targets: this.gameOver,
      ease: "Expo.easeInOut",
      duration: 1000,
      delay: 300,
      alpha: {
        getStart: () => 0,
        getEnd: () => 1,
      },
      yoyo: false,
      loop: 0,
    });

    this.tweens.add({
      targets: [this.gameOver],
      ease: "Linear",
      duration: 300,
      delay: 3000,
      y: {
        getStart: () => config.height / 2,
        getEnd: () => config.height / 2 - 50,
      },
      yoyo: false,
      loop: 0,
    });

    this.nextButton = this.add
      .sprite(config.width / 2, 740, "nextButton")
      .setAlpha(0)
      .setInteractive({ cursor: "pointer" });

    this.iconDisplay = this.add.sprite(config.width / 2 - 80, config.height / 2 + 50, "correctIcon").setAlpha(0);

    if (gameState.gameWin == false) {
      this.gameOver.setTexture("gameOver");
      this.nextButton.setTexture("retryButton");
      this.iconDisplay.setTexture("incorrectIcon");
      this.retryText = this.add
        .text(config.width / 2 - 140, config.height / 2 + 200, `Solve atleast 6 problems correctly \n to clear the game`, {
          fontFamily: "font1",
          fontSize: "18px",
          fill: "#ffffff",
        })
        .setAlign("center")
        .setAlpha(0);
      this.tweens.add({
        targets: [this.retryText],
        ease: "Linear",
        duration: 300,
        delay: 3000,
        alpha: {
          getStart: () => 0,
          getEnd: () => 1,
        },
        y: {
          getStart: () => config.height / 2 + 200,
          getEnd: () => config.height / 2 + 150,
        },
        yoyo: false,
        loop: 0,
      });
    } else {
      this.gameOver.setTexture("youWon");
      // config.audio.yay = this.sound.add("yay").setVolume(0.02);
      // config.audio.yay.play();

      this.endConfetti.play("endConfetti");
      this.confettiaudio.play();
    }

    this.finalScore = this.add
      .text(config.width / 2 - 140, config.height / 2 + 140, `${gameState.correct}/${gameState.questionNumber} Problems`, {
        fontFamily: "font1",
        fontSize: "18px",
        fill: "#ffffff",
      })
      .setAlpha(0);

    this.hintsUsed = this.add
      .text(config.width / 2 + 30, config.height / 2 + 140, `${gameState.hints} Hints Used`, {
        fontFamily: "font1",
        fontSize: "18px",
        fill: "#ffffff",
      })
      .setAlpha(0);

    this.hintDisplay = this.add
      .sprite(config.width / 2 + 80, config.height / 2 + 100, "hintIconMini")
      .setAlpha(0)
      .setScale(1);

    this.tweens.add({
      targets: [this.iconDisplay, this.hintDisplay],
      ease: "Linear",
      duration: 300,
      delay: 3000,
      y: {
        getStart: () => config.height / 2 + 100,
        getEnd: () => config.height / 2 + 50,
      },
      alpha: {
        getStart: () => 0,
        getEnd: () => 1,
      },
      yoyo: false,
      loop: 0,
    });

    this.tweens.add({
      targets: [this.finalScore, this.hintsUsed],
      ease: "Linear",
      duration: 300,
      delay: 3000,
      alpha: {
        getStart: () => 0,
        getEnd: () => 1,
      },
      y: {
        getStart: () => config.height / 2 + 140,
        getEnd: () => config.height / 2 + 100,
      },
      yoyo: false,
      loop: 0,
    });

    this.tweens.add({
      targets: [this.nextButton],
      ease: "Linear",
      duration: 300,
      delay: 3000,
      alpha: {
        getStart: () => 0,
        getEnd: () => 1,
      },
      y: {
        getStart: () => 740,
        getEnd: () => 650,
      },
      yoyo: false,
      loop: 0,
    });

    this.okButton = this.add
      .sprite(config.width / 2, 720, "okayButton")
      .setAlpha(0)
      .setInteractive({ cursor: "pointer" });

    this.nextButton.on("pointerup", (pointer) => {
      if (gameState.gameWin == false) {
        //config.audio.bgaudio.play();
        gameState.attempted = 0;
        gameState.score = 0;
        gameState.hints = 0;
        gameState.gameWin = false;
        gameState.qnum = 0;
        gameState.questionNumber = 0;
        gameState.correct = 0;
        (gameState.firstMistake = false), this.cameras.main.fadeOut(500, 255, 255, 255);

        this.cameras.main.once("camerafadeoutcomplete", () => {
          disablePointerEvents();
          this.scene.start("GameScene");
          this.scene.stop("EndScene");
        });
      } else {
        this.tweens.add({
          targets: [this.gameOver, this.iconDisplay, this.hintDisplay, this.finalScore, this.hintsUsed, this.nextButton],
          alpha: 0,
          duration: 300,
        });

        //this.spotlight.play("spotlightClose");

        //this.spotlight.play("spotlightOpen");
        this.time.delayedCall(
          1000,
          () => {
            //this.reward.play("rewardShow");

            var midHeight = config.height / 2;
            var midWidth = config.width / 2;
            this.yOffset = 100; // this value ensure the reward is placed bit above the midpoint
            this.yOffsetOfCircle = 85;

            /*
    A-----B-----C
    Glitter will move from A to B to C.(ie, glitter passing through 3 points)
    A is (fromx,fromy)
    B is (tox,toy)
    C is (endx,endy)

    if you are having only having just a line like A-----B
    add (endx,endy) values same as (fromx,fromy)
    */

            //>> change below values, center align the reward on figma, draw three lines according to where the gliter should move, take the cordinates.
            this.somev = 60;
            this.fromx = 603.7;
            this.fromy = 321.6 + this.somev - this.yOffset;
            this.tox = 610;
            this.toy = 368.8 + this.somev - this.yOffset;
            this.endx = 603.7;
            this.endy = 321.6 + this.somev - this.yOffset;

            this.centerxOfCircle = midWidth; //(1)
            this.centeryOfCircle = midHeight - this.yOffsetOfCircle;

            this.rewardAppearDelay = 1300; //how much delay is there from the scene start and the reward starting to appear from bottom
            this.rewardMotionDuration = 1350; //time taken for one top to bottom movement of reward

            //>> remove setTint  add bg accordingly
            //this.add.sprite(midWidth, midHeight, "bg").setTint(0x000);

            this.baseCircle = this.add.sprite(midWidth, midHeight, "baseCircle").setOrigin(0.5).setVisible(true).setScale(0.4);
            this.rewardLight = this.add.sprite(midWidth, midHeight, "rewardLightAnim").setOrigin(0.5).setVisible(true).setScale(0.4);

            this.compass = this.add
              .sprite(midWidth, midHeight + 170, "compass")
              .setOrigin(0.5)
              .setVisible(false)
              .setAngle(0)
              .setScale(0); //+250 is added to hide the reward image initially
            this.glitter = this.add
              .sprite(midWidth + 30, midHeight - 65, "glitter")
              .setOrigin(0.5)
              .setVisible(false)
              .setScale(0.8); // +30, -65 is added to offset position of spritesheet

            this.endanim = true;

            this.graphics = this.add.graphics();
            this.path = { t: 0.64, vec: new Phaser.Math.Vector2() };
            /*we defined a path, t=0 means, initial point in path, t=1 means end of path
    the movement of glitter is done by tweening the value of t form 0 to 1, such that it moves from intital point to end.
    vec: a new vector is created as a place holder.
    */

            // this.curve is a phaser.curve path, with goes through point A->B->C

            this.curve = new Phaser.Curves.Ellipse(this.centerxOfCircle, this.centeryOfCircle, 73, 80);
            //this.curve.lineTo(this.tox,this.toy);
            //this.curve.lineTo(this.endx,this.endy);

            //here t is tweened from 0->1 | on this.path
            this.tweens.add({
              targets: this.path,
              t: 0.7,
              ease: "Sine.easeInOut",
              duration: 2700,
              yoyo: true,
              repeat: -1,
            });

            // reward is setvisible and the appearing of reward is done after rewardAppearDelay

            this.time.delayedCall(
              this.rewardAppearDelay,
              () => {
                this.compass.setVisible(true);
              },
              [],
              this
            );

            this.tweens.add({
              targets: this.compass,
              x: midWidth,
              y: midHeight - this.yOffset,
              angle: 0,
              scale: 1,
              delay: this.rewardAppearDelay,
              ease: "Linear",
              duration: 1000,
              yoyo: false,
              repeat: 0,
              completeDelay: 0,
              onStart: () => {
                this.rewardReveal.play();
              },
              onComplete: () => {
                this.glitter.setVisible(true);
                this.glitter.play("showglitter");

                this.tweens.add({
                  targets: this.curve.p0,
                  y: this.centeryOfCircle + 70,
                  ease: "Sine.easeInOut",
                  duration: this.rewardMotionDuration,
                  yoyo: true,
                  repeat: -1,
                });

                this.tweens.add({
                  targets: this.compass,
                  y: { from: midHeight - this.yOffset, to: midHeight + 70 - this.yOffset },
                  ease: "Sine.easeInOut",
                  duration: this.rewardMotionDuration,
                  yoyo: true,
                  repeat: -1,
                  completeDelay: 0,
                });

                this.tweens.add({
                  targets: this.compass,
                  y: { from: midHeight - this.yOffset, to: midHeight + 70 - this.yOffset },
                  ease: "Sine.easeInOut",
                  duration: this.rewardMotionDuration,
                  yoyo: true,
                  repeat: -1,
                  completeDelay: 0,
                });
              },
            });

            this.time.delayedCall(
              1500,
              () => {
                //this.rewardReveal.play();
              },
              this
            );

            this.baseCircle.play("circleopen").once("animationcomplete", () => {
              this.baseCircle.play("circleglitterloop");
            });

            this.rewardLight.play("rewardopen");

            this.tweens.add({
              targets: this.okButton,
              ease: "Linear",
              duration: 300,
              delay: 3000,
              alpha: 1,
              y: 650,
            });

            this.rewardEarned = this.add.sprite(577, 126, "rewardEarned").setOrigin(0);
            this.rewardName = this.add.sprite(640, 560, "rewardName").setOrigin(0.5, 0);
          },
          this
        );

        //this.spotlight.on(Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + "spotlightClose", () => {}, this);
      }
    });

    this.okButton.on("pointerup", () => {
      this.okButton.setTexture("disable_okayButton");
      this.okButton.removeInteractive();
    });

    this.nextButton.on("pointerover", () => {
      if (gameState.gameWin == false) {
        this.nextButton.setTexture("hover_retryButton");
      } else {
        this.nextButton.setTexture("hover_nextButton");
      }
    });
    this.nextButton.on("pointerout", () => {
      if (gameState.gameWin == false) {
        this.nextButton.setTexture("retryButton");
      } else {
        this.nextButton.setTexture("nextButton");
      }
    });

    this.okButton.on("pointerover", () => {
      this.okButton.setTexture("hover_okayButton");
    });
    this.okButton.on("pointerout", () => {
      this.okButton.setTexture("okayButton");
    });
  }

  update() {
    if (this.endanim) {
      this.graphics.clear();

      //show the movement path of glitter
      //this.graphics.lineStyle(5, 0xffffff, 1);
      // this.curve.draw(this.graphics);

      //below lines get executed continuously, such that glitter position will change
      this.curve.getPoint(this.path.t, this.path.vec); //this.curve is the route in which we need glitter to move, getpoint() will calculate the vector location according to tween of "t" and stored on vec
      this.glitter.setPosition(this.path.vec.x, this.path.vec.y); //from vec we set the position of glitter
    }
  }
}
